<template>
    <div ref="$goBackToTop" @click="goBackToTop" class="goBackToTop">
        <img src="../assets/images/go-back.png" alt="">
    </div>
</template>

<script>
    export default {
        name: "GoBackToTop",
        props: {
            isWindowScroll: {
                type: Boolean,
                default: false,
            }
        },
        methods: {
            goBackToTop() {
                if (this.isWindowScroll) {
                    window.scroll({
                        top: 0,
                        left: 0,
                        behavior: 'smooth'
                    })
                } else {
                    const goBackEle = this.$refs.$goBackToTop
                    const goBackEleParent = goBackEle.parentNode
                    goBackEleParent.scrollTo({
                        top: 0,
                        behavior: 'smooth'
                    })
                }
            }
        }
    }
</script>

<style scoped>
    .goBackToTop {
        text-align: right;
    }

    .goBackToTop::after {
        content: '';
        display: inline-block;
        width: 100%;
        height: 46px;
        border-top: 1px solid black;
    }

    .goBackToTop img {
        width: 64px;
        height: 64px;
        padding: 54px 19px 22px 0
    }
</style>